import {
  type ComputedRef,
  computed,
  onMounted,
  onUnmounted,
  ref,
  toValue,
  watch,
} from '#imports';
import { usePageDeactive, usePageReactive } from '#imports';
import { getAuthReward } from '@core/api/common';
import { createIntervalRunTask } from '@core/utils/utility';

export const useAuthReward = (
  active: ComputedRef<boolean> = computed(() => true),
  delay: number = 0, // 延时启动，单位毫秒，默认0
): any => {
  const data = ref<null | object>(null);
  const loading = ref(false);
  const fetchData = () => {
    loading.value = true;
    getAuthReward()
      .then((res) => {
        data.value = res;
      })
      .catch((e) => {
        console.error('获取勋章信息失败', e);
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const INTERVAL_TIME = 3; //2秒轮询一次
  const { startTask: startPoller, stopTask: stopPoller } =
    createIntervalRunTask(INTERVAL_TIME, fetchData);

  onMounted(async () => {
    await new Promise((resolve) => setTimeout(resolve, delay));
    toValue(active) && startPoller();
  });
  onUnmounted(() => {
    stopPoller();
  });

  usePageReactive(() => {
    toValue(active) && startPoller();
  });
  usePageDeactive(() => {
    stopPoller();
  });

  watch(
    () => toValue(active),
    (isActive) => {
      if (isActive) {
        startPoller();
      } else {
        stopPoller();
      }
    },
  );

  return {
    data,
    loading,
    startPoller,
    stopPoller,
  };
};
